// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DWwf","rootMobile":"styles_rootMobile__3BHtG"};